(function () {
  var RECAPTCHA_SITE_KEY = "6LcheOMtAAAAAM7GkhzqK0gjTfX9sr9VIQYVvMUK";
  var RECAPTCHA_ACTION = "finance_submit";
  var RECAPTCHA_TOKEN_TIMEOUT_MS = 6000;

  var form = document.getElementById("gaf-form");
  if (!form) return;

  var honeypotField = document.createElement("input");
  honeypotField.type = "text";
  honeypotField.name = "website_url";
  honeypotField.setAttribute("autocomplete", "off");
  honeypotField.setAttribute("tabindex", "-1");
  honeypotField.style.position = "absolute";
  honeypotField.style.left = "-9999px";
  honeypotField.style.opacity = "0";
  honeypotField.style.height = "0";
  honeypotField.style.width = "0";
  form.appendChild(honeypotField);

  var formStartedAt = Math.floor(Date.now() / 1e3),
      creditToggle = document.getElementById("gaf-credit-toggle"),
      creditBody = document.getElementById("gaf-credit-body"),
      toggleIcon = creditToggle.querySelector(".gaf-toggle-icon"),
      einRadios = form.querySelectorAll('input[name="ein"]'),
      ssnLabel = document.getElementById("gaf-ssn-label"),
      ssnInput = document.getElementById("gaf-ssn"),
      einNote = document.getElementById("gaf-ein-note"),
      submitMsg = document.getElementById("gaf-submit-msg");

  // Load the reCAPTCHA v3 script as soon as this file runs, so a token is
  // ready well before the applicant submits. Harmless if it's already on
  // the page (e.g. this script re-runs after a soft navigation).
  (function loadRecaptcha() {
    if (document.querySelector('script[src*="recaptcha/api.js"]')) return;
    var script = document.createElement("script");
    script.src = "https://www.google.com/recaptcha/api.js?render=" + RECAPTCHA_SITE_KEY;
    script.async = true;
    document.head.appendChild(script);
  })();

  // Resolves with a reCAPTCHA token, or "" if the library never loads or
  // never responds within the timeout. Submission proceeds either way -
  // this is one layer of bot protection among several (HMAC-signed App
  // Proxy requests, honeypot, timing check, rate limiting), not a hard gate
  // on a third-party script loading successfully for every visitor.
  function getRecaptchaToken() {
    return new Promise(function (resolve) {
      var settled = false;
      function finish(token) {
        if (settled) return;
        settled = true;
        resolve(token || "");
      }

      setTimeout(function () {
        finish("");
      }, RECAPTCHA_TOKEN_TIMEOUT_MS);

      if (typeof grecaptcha === "undefined" || !grecaptcha.ready) {
        return;
      }

      grecaptcha.ready(function () {
        grecaptcha
          .execute(RECAPTCHA_SITE_KEY, { action: RECAPTCHA_ACTION })
          .then(finish)
          .catch(function () {
            finish("");
          });
      });
    });
  }

  creditToggle.addEventListener("click", function () {
    var open = creditBody.style.display !== "none";
    creditBody.style.display = open ? "none" : "flex";
    toggleIcon.textContent = open ? "+" : "−";
  });

  einRadios.forEach(function (radio) {
    radio.addEventListener("change", function () {
      einNote.textContent =
        "*To apply using an EIN, a minimum of three(3) years of business credit history is required for business credit approval. If you do not meet this requirement or do not have an EIN, please apply as an individual using your SSN.";
      einNote.style.display = "block";

      var yearEmpField = document.getElementById("gaf-year-emp-field"),
          yearEmpInput = document.getElementById("gaf-year_emp"),
          annualLabel = document.getElementById("gaf-annual-salary-label");

            if (radio.value === "EIN") {
        ssnLabel.textContent = "Employer Identification Number *";
        ssnInput.placeholder = "XX-XXXXXXX";
        annualLabel.textContent = "Estimated Annual Revenue *";
        yearEmpField.style.display = "none";
        yearEmpInput.value = "";
        yearEmpInput.required = false;
        yearEmpInput.disabled = true;
        showError(yearEmpInput, "");
      } else {
        ssnLabel.textContent = "Social Security Number *";
        ssnInput.placeholder = "XXX-XX-XXXX";
        annualLabel.textContent = "Annual Salary *";
        yearEmpField.style.display = "";
        yearEmpInput.disabled = false;
        yearEmpInput.required = true;
      }

      // An EIN and an SSN are different numbers in different formats - never
      // carry one over as if it were the other when the applicant flips
      // between the two before submitting.
      ssnInput.value = "";
      showError(ssnInput, "");

      if (creditBody.style.display === "none" || !creditBody.style.display) {
        creditBody.style.display = "flex";
        toggleIcon.textContent = "−";
      }
    });
  });

  // Auto-inserts the hyphen(s) as the applicant types, so they never have to
  // find the hyphen key themselves (hard to reach on an iPhone's numeric
  // keypad) - EIN: XX-XXXXXXX, SSN: XXX-XX-XXXX. Any non-digit character is
  // stripped the instant it's typed, so letters can never end up in this
  // field at all, not just rejected at submit time.
  function formatSsnOrEin(digits, mode) {
    digits = digits.slice(0, 9);
    if (mode === "EIN") {
      return digits.length <= 2 ? digits : digits.slice(0, 2) + "-" + digits.slice(2);
    }
    if (digits.length <= 3) return digits;
    if (digits.length <= 5) return digits.slice(0, 3) + "-" + digits.slice(3);
    return digits.slice(0, 3) + "-" + digits.slice(3, 5) + "-" + digits.slice(5);
  }

  // Blocks a non-digit keystroke before it ever lands in the field (letters,
  // symbols, even the hyphen itself since that's auto-inserted). Keyboard
  // shortcuts (copy/paste/select-all) and navigation/editing keys still work
  // normally - a pasted value is still caught and cleaned up by the "input"
  // listener below, since keydown alone can't intercept pasting.
  ssnInput.addEventListener("keydown", function (e) {
    if (e.ctrlKey || e.metaKey || e.altKey) return;
    var allowedKeys = ["Backspace", "Delete", "Tab", "ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "Home", "End", "Enter", "Escape"];
    if (allowedKeys.indexOf(e.key) !== -1) return;
    if (!/^\d$/.test(e.key)) {
      e.preventDefault();
    }
  });

  ssnInput.addEventListener("input", function () {
    var einChecked = form.querySelector('input[name="ein"]:checked');
    var mode = einChecked && einChecked.value === "EIN" ? "EIN" : "SSN";
    var cursorPos = ssnInput.selectionStart;
    var digitsBeforeCursor = ssnInput.value.slice(0, cursorPos).replace(/\D/g, "").length;
    var digits = ssnInput.value.replace(/\D/g, "");

    ssnInput.value = formatSsnOrEin(digits, mode);

    // Keep the cursor after the same number of digits it was after before
    // reformatting, so typing/backspacing in the middle doesn't jump around.
    var pos = 0, seen = 0;
    while (pos < ssnInput.value.length && seen < digitsBeforeCursor) {
      if (/\d/.test(ssnInput.value[pos])) seen++;
      pos++;
    }
    ssnInput.setSelectionRange(pos, pos);
  });

  var FIELD_ERROR_MESSAGES = {
    fname: "First name is required.",
    lname: "Last name is required.",
    finance_equipment: "Please select an option.",
    past_financed: "Please select an option.",
    no_of_machine: "Please select an option.",
    business_name: "Business/DBA name is required.",
    primary_phone: "Enter a valid phone number.",
    Secondary_phone: "Enter a valid phone number.",
    email: "Enter a valid email address.",
    address: "Physical address is required.",
    city: "City is required.",
    state: "State is required.",
    zipcode: "Enter a valid zip code.",
    ein: "Please select EIN or SSN.",
    ssn: "Enter a valid SSN or EIN.",
    ecompany_name: "Employer company name is required.",
    employer_phone: "Enter a valid phone number.",
    annual_salary: "Enter a valid annual salary.",
    year_emp: "Enter years employed."
  };

  function showError(field, msg) {
    var fieldWrap = field.closest(".gaf-field");
    var errEl = fieldWrap ? fieldWrap.querySelector(".gaf-error") : null;
    if (errEl) errEl.textContent = msg || "";
    if (fieldWrap) fieldWrap.classList.toggle("gaf-has-error", !!msg);
  }

  function validate() {
    var valid = true;

    form.querySelectorAll("[required]").forEach(function (el) {
      showError(el, "");

      if (el.type === "radio") {
        var group = form.querySelectorAll('input[name="' + el.name + '"]');
        var checked = Array.from(group).some(function (r) {
          return r.checked;
        });
        if (!checked) {
          showError(el, FIELD_ERROR_MESSAGES[el.name]);
          valid = false;
        }
        return;
      }

      if (!el.value.trim()) {
        showError(el, FIELD_ERROR_MESSAGES[el.name]);
        valid = false;
      }
    });

    var email = document.getElementById("gaf-email");
    if (email.value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value)) {
      showError(email, FIELD_ERROR_MESSAGES.email);
      valid = false;
    }

    var zip = document.getElementById("gaf-zipcode");
    if (zip.value && !/^\d{5}(-\d{4})?$/.test(zip.value)) {
      showError(zip, FIELD_ERROR_MESSAGES.zipcode);
      valid = false;
    }

    ["gaf-primary_phone", "gaf-employer_phone"].forEach(function (id) {
      var el = document.getElementById(id);
      if (el.value && !/^[\d\s\-\(\)\+]{7,}$/.test(el.value)) {
        showError(el, FIELD_ERROR_MESSAGES[el.name]);
        valid = false;
      }
    });

    var secPhone = document.getElementById("gaf-Secondary_phone");
    if (secPhone && secPhone.value && !/^[\d\s\-\(\)\+]{7,}$/.test(secPhone.value)) {
      showError(secPhone, FIELD_ERROR_MESSAGES.Secondary_phone);
      valid = false;
    }

    var einChecked = form.querySelector('input[name="ein"]:checked');
    if (einChecked && ssnInput.value) {
      var isEin = einChecked.value === "EIN";
      var pattern = isEin ? /^\d{2}-\d{7}$/ : /^\d{3}-\d{2}-\d{4}$/;
      if (!pattern.test(ssnInput.value)) {
        showError(ssnInput, FIELD_ERROR_MESSAGES.ssn);
        valid = false;
      }
    }

    return valid;
  }

  function setFieldErrorsFromServer(errors) {
    Object.keys(errors).forEach(function (name) {
      var el = form.querySelector('[name="' + name + '"]');
      if (el) showError(el, errors[name]);
    });
  }

  form.addEventListener("submit", function (e) {
    e.preventDefault();

    if (!validate()) {
      submitMsg.textContent = "Please correct the highlighted fields above.";
      submitMsg.style.color = "#c0392b";
      return;
    }

    // Disabled before the (async) reCAPTCHA token fetch, not just before the
    // network request, so a double-click during that brief wait can't fire
    // two submissions.
    var submitBtn = form.querySelector(".gaf-submit");
    submitBtn.disabled = true;
    submitMsg.textContent = "";

    getRecaptchaToken().then(function (recaptchaToken) {
      var payload = {};
      new FormData(form).forEach(function (value, key) {
        payload[key] = value;
      });
      if (payload.ein === "EIN") delete payload.year_emp;
      payload.website_url = honeypotField.value.trim();
      payload.form_started_at = String(formStartedAt);
      payload.recaptcha_token = recaptchaToken;

      fetch("/apps/financing-application/submit", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      })
        .then(function (res) {
          submitBtn.disabled = false;
          if (res.ok) {
            submitMsg.textContent = "Application submitted — redirecting...";
            submitMsg.style.color = "#2c3e50";
            window.location.href = "/pages/financing-thank-you";
            return;
          }
          throw new Error("submit_failed");
        })
        .catch(function () {
          submitBtn.disabled = false;
          submitMsg.textContent =
            "There was a problem submitting your application. Please check your information and try again, or contact us directly.";
          submitMsg.style.color = "#c0392b";
        });
    });
  });
})();
